module.exports = __webpack_public_path__ + "static/media/logo.ce76c17a.svg";